import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const linearConfigurationRequestQuoteConfirmationPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.linearConfigurationRequestQuoteConfirmation(),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<void>>("/page-data/requestLinearConfigurationQuote/confirmation"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
